import * as React from "react";
import { PopupBody, Popup } from "./Popup";
import { useAppContext } from "../Contexts/AppContext";

export const SearchPopup = (): JSX.Element => {
    const { isMobile } = useAppContext();

    const text = (
        <div>
            Karti tuvināt meklējot pēc novada vai pagasta. Objektus meklēt pēc zemes vienības kadastra apzīmējuma vai
            LVM autoceļa nosaukuma.
            <br />
            Objektus var identificēt arī noklikšķinot uz attiecīgā objekta uz kartes.
            <br />
            Atrasto īpašumu vai LVM autoceļu pievieno pie Darbības vietas objektu saraksta.
        </div>
    );

    return (
        <Popup id="search-popup" isMobile={isMobile} sameContainer={true}>
            <div className="triangle-top"></div>
            <PopupBody isMobile={isMobile}>{text}</PopupBody>
        </Popup>
    );
};
